
	import { defineComponent, ref, watch, onMounted } from 'vue'
	import AppList from './AppList.vue'
	import ReviewList from './ReviewList.vue'
	import { useRoute, useRouter } from 'vue-router'

	export default defineComponent({
		setup() {
			const activeKey = ref('')
			const router = useRouter()
			const route = useRoute()
			const tabClick = (value: string) => {
				router.push({
					name: value
				})
			}
			watch(
				() => route.name,
				() => {
					activeKey.value = String(route.name || '')
				}
			)
			onMounted(() => {
				activeKey.value = String(route.name || '')
			})
			return {
				activeKey,
				tabClick
			}
		}
	})
